import React from 'react';
import { Route } from 'react-router-dom';

import EditUser from '../edit-user';
import AddUser from './add-user';
import All from './all';
import DeleteUser from './delete';

export default () => (
  <div id="dashboard">
    <Route exact path="/settings/users" component={All} />

    <Route path="/settings/users/add" component={AddUser} />

    <Route path="/settings/users/user/:id/delete" component={DeleteUser} />

    <Route exact path="/settings/users/user/:id" component={EditUser} />
  </div>
);



// WEBPACK FOOTER //
// ./src/views/settings/users/index.js